
import React, { useState } from "react";
import SpHeader from "../../Components/mainHeader/SpHeader";
import ApplyFilterHeader from "../../Components/ApplyFilterHeader";
import styles from './SitePerformance.module.css';
import { Link } from "react-router-dom";
import ReactECharts from 'echarts-for-react';
import infraImg1 from '../../assets/images/sts_mains.svg';
import infraImg2 from '../../assets/images/sts_genset.svg';
import infraImg3 from '../../assets/images/sts_battery.svg';
import infraImg4 from '../../assets/images/sts_solar.svg';
import infraImg5 from '../../assets/images/sts_rectifier.svg';
import SssTargets from "../../screensUi/SssTargets";
import SssSiteLoadAndConsumption from "../../screensUi/SssSiteLoadAndConsumption";
import SssAlaramsShow from "../../screensUi/SssAlaramsShow";
import SingleSiteDetailRightNav from "../../Modals/SingleSiteDetailRightNav";
 

function SingleSiteSummary() {
    const [isAlaramVisible, setAlaramVisible] = useState(false);

    // Step 3: Function to toggle visibility
    const toggleAlaramVisibility = () => {
        setAlaramVisible(!isAlaramVisible);
    };
    // 
    const alaramsCircleChart = {
        title: {
            text: 'kWh',
            show: false,
            left: '3',
            width: "100%",
            textStyle: {
                textAlign: 'center',
                fontSize: 12,
                fontWeight: '500',
                fontFamily: 'Roboto, sans-serif',
            },
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {

            left: 'center',
            top: '0px',
            show: true,
            data: ['Mains', 'Battery', 'DG', 'Solar', 'Mains-Battery', 'Undetermined'],
            itemHeight: 10,
            itemWidth: 10,
            textStyle: {
                fontSize: 13,
                color: '#000',
                fontWeight: '600'
            },

        },
        grid: {
            left: '10px',
            top: '0px',
            right: '10px',
            bottom: '0%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'value',
                boundaryGap: true,
                // data: [0, 5, 10, 15, 20, 24],
                show: false,
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            },
        ],

        yAxis: [
            {
                type: 'value',

                show: false,
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],

        series: [
            {
                name: 'Alarms',
                type: 'pie',
                radius: '70%',
                data: [
                    { value: 25, name: '25%', itemStyle: { color: '#F13534' } },
                    { value: 10, name: '15%', itemStyle: { color: '#32864B' } },
                    { value: 50, name: '50%', itemStyle: { color: '#0058FF' } },
                    { value: 15, name: '10%', itemStyle: { color: '#F1B400' } },
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]

    };

    const breadcrumbs = [
        { label: 'Sites', link: '' },
        { label: 'Single Site Summary', link: '/SingleSiteSummary' },
    ];

    const getUrlFromLocalStorage = localStorage.getItem('summaryParentUrl');
    let parenturl = '/AmTransformer';

    if (getUrlFromLocalStorage !== '' && getUrlFromLocalStorage !== undefined) {
        parenturl = getUrlFromLocalStorage;
    }

    const summaryObj = {
        minimize: 'Minimise',
        otherName: "Summary",
        minUrl: parenturl,
        otherUrl: '/SingleSiteSummary',
        // icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8318 8.00305L15.1998 7.87905V8.52305C15.1998 8.74305 15.3798 8.92305 15.5998 8.92305H17.1998C17.4198 8.92305 17.5998 8.74305 17.5998 8.52305V2.12305C17.5998 1.90305 17.4198 1.72305 17.1998 1.72305H15.5998C15.3798 1.72305 15.1998 1.90305 15.1998 2.12305V2.63505L14.3998 2.90305L13.6718 2.65905L13.1918 0.439047C13.1518 0.255047 12.9878 0.123047 12.7998 0.123047H11.1998C11.0118 0.123047 10.8478 0.255047 10.8078 0.439047L10.3278 2.65905L9.59983 2.90305L8.79983 2.63505V2.12305C8.79983 1.90305 8.61983 1.72305 8.39983 1.72305H6.79983C6.57983 1.72305 6.39983 1.90305 6.39983 2.12305V8.52305C6.39983 8.74305 6.57983 8.92305 6.79983 8.92305H8.39983C8.61983 8.92305 8.79983 8.74305 8.79983 8.52305V7.87905L9.16783 8.00305L5.84783 23.323H1.59983V24.123H22.3998V23.323H18.1518L14.8318 8.00305ZM15.9998 2.52305H16.7998V8.12305H15.9998V2.52305ZM7.99983 8.12305H7.19983V2.52305H7.99983V8.12305ZM16.8238 20.979L12.9798 19.255L16.1438 17.835L16.8238 20.979ZM15.9678 17.035L12.3998 18.635V15.743L15.9438 16.927L15.9678 17.035ZM11.1998 9.72305V3.32305H12.7998V9.72305H11.1998ZM15.7478 16.019L13.2638 15.191L15.4118 14.475L15.7478 16.019ZM15.2438 13.687L12.3998 14.635V12.363L15.2318 13.639L15.2438 13.687ZM12.9758 11.747L15.0229 12.6666L14.6598 10.991L12.9758 11.747ZM14.2758 3.70305C14.3158 3.71505 14.3598 3.72305 14.4038 3.72305C14.4478 3.72305 14.4878 3.71505 14.5318 3.70305L15.2038 3.47905V7.03505L14.6638 7.21505L13.8718 3.56705L14.2758 3.70305ZM13.6038 6.10305L13.8198 7.10705L13.6038 7.03505V6.10305ZM13.6038 7.87905L14.0198 8.01905L14.2318 8.99105L13.6078 8.67905V7.88305L13.6038 7.87905ZM13.2038 10.523C13.4238 10.523 13.6038 10.343 13.6038 10.123V9.57105L14.4478 9.99105L14.4918 10.187L12.4078 11.127V10.523H13.2038ZM11.5238 0.923047H11.5998V1.72305H12.3998V0.923047H12.4758L12.8238 2.52305H11.1758L11.5238 0.923047ZM10.3998 6.10305V7.03505L10.1838 7.10705L10.3998 6.10305ZM10.3998 7.87905V8.67505L9.77583 8.98705L9.98783 8.01505L10.4038 7.87505L10.3998 7.87905ZM8.79983 7.03505V3.47905L9.47183 3.70305C9.51183 3.71505 9.55583 3.72305 9.59983 3.72305C9.64383 3.72305 9.68383 3.71505 9.72783 3.70305L10.1318 3.56705L9.33983 7.21505L8.79983 7.03505ZM9.33983 10.987L11.0238 11.743L8.97583 12.663L9.33983 10.983V10.987ZM8.58383 14.471L10.7318 15.187L8.24783 16.015L8.58383 14.471ZM7.85583 17.831L11.0198 19.251L7.17583 20.975L7.85583 17.831ZM11.5998 23.319H6.66783L6.96383 21.943L11.5998 19.863V23.315V23.319ZM11.5998 18.631L8.03183 17.031L8.05583 16.923L11.5998 15.739V18.631ZM11.5998 14.631L8.75583 13.683L8.76783 13.635L11.5998 12.359V14.631ZM11.5998 11.123L9.51583 10.183L9.55983 9.98705L10.4038 9.56705V10.119C10.4038 10.339 10.5838 10.519 10.8038 10.519H11.6038V11.123H11.5998ZM12.3998 23.319V19.867L17.0358 21.947L17.3318 23.323H12.3998V23.319ZM0.8 23.3231H0V24.1231H0.8V23.3231ZM23.2001 23.3231H24.0001V24.1231H23.2001V23.3231ZM12.3998 4.12305H11.5998V4.92305H12.3998V4.12305ZM11.5998 8.12305H12.3998V8.92305H11.5998V8.12305ZM5.38388 6.97104L5.81988 6.29904C5.47188 6.07504 5.26788 5.69904 5.26788 5.29504C5.26788 4.89104 5.45188 4.55504 5.76788 4.33104L5.30788 3.67904C4.78388 4.05104 4.46788 4.65504 4.46788 5.29504C4.46788 5.97104 4.81188 6.59904 5.38388 6.97104ZM4.11203 2.55512L4.62803 3.16712C3.99603 3.70312 3.63203 4.45112 3.63203 5.29512C3.63203 6.13912 4.01603 6.93112 4.68403 7.47112L4.18003 8.09512C3.32403 7.40312 2.83203 6.34712 2.83203 5.29512C2.83203 4.24312 3.30003 3.24312 4.11203 2.55512ZM3.01209 9.22696L3.53609 8.61896C2.56009 7.77896 2.00009 6.56696 2.00009 5.29496C2.00009 4.02296 2.54009 2.85496 3.48009 2.01896L2.94809 1.42296C1.84009 2.41096 1.20009 3.82296 1.20009 5.29496C1.20009 6.76696 1.86009 8.23096 3.01209 9.22296V9.22696ZM18.696 6.96691L18.236 6.31491C18.552 6.09091 18.736 5.75491 18.736 5.35091C18.736 4.94691 18.532 4.57091 18.184 4.34691L18.62 3.67491C19.192 4.04691 19.536 4.67491 19.536 5.35091C19.536 5.99091 19.22 6.59491 18.696 6.96691ZM21.168 5.351C21.168 4.263 20.676 3.243 19.82 2.551L19.316 3.175C19.984 3.715 20.368 4.507 20.368 5.351C20.368 6.195 20.004 6.943 19.372 7.479L19.888 8.091C20.7 7.403 21.168 6.403 21.168 5.351ZM20.464 2.02705L20.988 1.41905V1.42305C22.14 2.41505 22.8 3.87905 22.8 5.35105C22.8 6.82305 22.16 8.23505 21.052 9.22305L20.52 8.62705C21.46 7.79105 22 6.62305 22 5.35105C22 4.07905 21.44 2.86705 20.464 2.02705Z" fill="black"/>  </svg>`
    }

  // Step 3: Create a state variable for Offcanvas visibility
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };


    return (
        <div className="sitePerformance_wrapper">
            <SpHeader breadcrumbs={breadcrumbs} summaryObj={summaryObj} isSummaryButton />
            <div className="contentWrap">
                <ApplyFilterHeader />
                <div className="sts_contentMain">
                    <div className={styles.sts_topHeader}>
                        <div className={styles.sts_goodSite}>
                            <span>Good Site</span>
                        </div>
                        <h4 className={styles.title}> Status </h4>

                        <div className={`sts_status_row ${styles.status_border}`}>
                            <div className="sts_status_box sts_connected">
                                <span>Connected</span>
                                <i></i>
                            </div>
                            <div className="sts_status_box sts_solar">
                                <span>Solar</span>
                                <i></i>
                            </div>
                            <div className="sts_status_box sts_battery">
                                <span>Battery</span>
                                <i></i>
                            </div>
                            {/* <div className="sts_status_box sts_main">
                                <span>Mains</span>
                                <i></i>
                            </div> */}

                            {/* <div className="sts_status_box sts_genset">
                                <span>Genset</span>
                                <i></i>
                            </div> */}
                            {/* <div className="sts_status_box sts_rectifier">
                                <span>Rectifier</span>
                                <i></i>
                            </div> */}
                            {/* <div className="sts_status_box sts_outage">
                                <span>Outage</span>
                                <i></i>
                            </div> */}
                            {/* <div className="sts_status_box sts_wind">
                                <span>Wind</span>
                                <i></i>
                            </div> */}
                            <div className="sts_status_box sts_csu">
                                <span>CSU</span>
                                <i></i>
                            </div>
                        </div>
                        <h4 className={styles.title}> Performance </h4>
                        <div className={styles.labels}>
                            <span>Energy <i></i></span>
                            <span>CO2  <i></i></span>
                            <span>NAR <i></i></span>
                            <span>FC <i></i></span>
                            <span>LS <i></i></span>
                        </div>

                        <div className={styles.sts_date_status}>Last Updated: October 05,2020</div>
                    </div>
                    <div className="sts_content">
                        <div className="d-flex flex-wrap">
                            <div className={`col pe-2 pb-2 ${styles.box_small}`}>
                                <div className="box_card has_info_icon h-100">
                                    <div className="box_info_flexible">
                                        <h3 className='chartTitleHeading  pb-0 pt-0'>
                                            Site Details
                                        </h3>
                                        <div className='box_info'>
                                            <i className='box_info_icon'></i>
                                        </div>
                                    </div>
                                    <div className="sts_siteDetail_data">
                                        <div className="row pb-3">
                                            <div className="col-6">
                                                <p className="label16 weight6">AMKM - 03</p>
                                            </div>
                                            <div className="col-5 ms-auto">
                                                <p className="label15 weight5">Abbottabad</p>
                                            </div>
                                        </div>
                                        <div className="row pb-2">
                                            <div className="col-6">
                                                <p className="label15 weight4">Site Type</p>
                                            </div>
                                            <div className="col-5 ms-auto">
                                                <p className="label15 weight5">BTS + HUB</p>
                                            </div>
                                        </div>
                                        <div className="row pb-3">
                                            <div className="col-6">
                                                <p className="label15 weight4">Site Category</p>
                                            </div>
                                            <div className="col-5 ms-auto">
                                                <p className="label15 weight5">Host Sharing</p>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end  pt-2">
                                            <Link onClick={toggleOffcanvas} className={styles.moreBtn}>View more <i><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                <path d="M12.6654 8.01497H3.33203" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.33203 11.349L12.6654 8.01562" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M9.33203 4.68164L12.6654 8.01497" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg></i></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col pb-2">
                                <div className="box_card has_info_icon h-100">
                                    <div className="box_info_flexible">
                                        <h3 className='chartTitleHeading  pb-0 pt-0'>
                                            Infrastructure
                                        </h3>
                                        <div className='box_info'>
                                            <i className='box_info_icon'></i>
                                        </div>
                                    </div>
                                    <div className={styles.sts_infra_row}>
                                        <ul className="d-flex">
                                            <li>
                                                <div className={styles.infrastructure_box}>
                                                    <h4><i className="infra_label bg_blue"><img src={infraImg1} alt="#"></img></i>Transformer</h4>
                                                    <h3>25 <sub>kVA</sub></h3>
                                                    <label className="color_red">Over-Size</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={styles.infrastructure_box}>
                                                    <h4><i className="infra_label bg_green"><img src={infraImg2} alt="#"></img></i>Generator</h4>
                                                    <h3>13  <sub>kVA</sub></h3>
                                                    <label className="color_green_pigment">Right-Size</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={styles.infrastructure_box}>
                                                    <h4><i className="infra_label bg_blue_navy"><img src={infraImg3} alt="#"></img></i>Battery</h4>
                                                    <h3>Li+ 400.0 <sub>Ah</sub></h3>
                                                    <label className="color_blue">Under-Size</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={styles.infrastructure_box}>
                                                    <h4><i className="infra_label bg_yellow"><img src={infraImg4} alt="#"></img></i>Solar</h4>
                                                    <h3>--  <sub> kW</sub></h3>
                                                    <label className="color_black">No Solar</label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className={styles.infrastructure_box}>
                                                    <h4><i className="infra_label bg_grey_cement"><img src={infraImg5} alt="#"></img></i>Rectifier</h4>
                                                    <h3>18.0 <sub>kW</sub></h3>
                                                    <label className="color_blue">Under-Size</label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="d-flex justify-content-end pt-2">
                                        <Link className={styles.moreBtn}>View more <i><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                            <path d="M12.6654 8.01497H3.33203" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.33203 11.349L12.6654 8.01562" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.33203 4.68164L12.6654 8.01497" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className={`col ps-2 pb-2 ${styles.box_small}`}>
                                <div className="box_card has_info_icon h-100">
                                    <div className="box_info_flexible">
                                        <h3 className='chartTitleHeading  pb-0 pt-0'>
                                            Alarms
                                        </h3>
                                        {
                                            isAlaramVisible ? <div className={styles.viewCloseBoxSmallPos}>
                                                <div onClick={toggleAlaramVisibility} className={styles.closeBoxBtn}></div>
                                            </div>
                                                :
                                                <div className='box_info'><i className='box_info_icon'></i>  </div>

                                        }
                                    </div>
                                    {/* */}

                                    {
                                        isAlaramVisible ? <div className={styles.sss_alarams_chart}>
                                            <ReactECharts option={alaramsCircleChart} opts={{ renderer: 'svg' }} style={{ height: 130 }} />
                                        </div>
                                            :
                                            <>
                                                <div className={styles.alaramsNo}>
                                                    <h3>20</h3>
                                                    <span>Total</span>
                                                </div>
                                                <div className="d-flex justify-content-end pt-2">
                                                    <Link onClick={toggleAlaramVisibility} className={styles.moreBtn}>View more <i><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                        <path d="M12.6654 8.01497H3.33203" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.33203 11.349L12.6654 8.01562" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.33203 4.68164L12.6654 8.01497" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg></i></Link>
                                                </div>
                                            </>
                                    } 

                                </div>
                            </div>
                        </div>
                        {
                            isAlaramVisible ? <SssAlaramsShow />
                                :
                                ''
                        }
                        <SssTargets />
                        <SssSiteLoadAndConsumption />
                    </div>
                </div>
            </div>
            {/* single site side panel nav component */}
            <SingleSiteDetailRightNav showOffcanvas={showOffcanvas} toggleOffcanvas={toggleOffcanvas}/>
        </div>
    )
}
export default SingleSiteSummary;